
export const RoutesList = {
    Login : {
      path : "/"
    },
    Dashboard : {
        Path:"/Dashboard",
    },
    Analytics : {
        path:"/Analytics"
    },
    Details : {
        path:"/Dashboard/:id/details/:catName/:uuid"
    },
    AllReadings : {
        path:"/readings"
    },
    AllDevices:{
      path:"/devices"
    },
    DeviceDetail:{
      path:"/readings/:imei"
    },
    SignUp:{
        path:"/SignUp"
    },
    UsersList:{
        path:"/Users"
    },
    AdminsList:{
        path:"/Admins"
    },
    AddUser : {
        path:"/Add-new-user"
    },
    MyDevices : {
        path : "/My-devices"
    },
    AllClients:{
        path : "/clients"
    }
}